module.exports = __webpack_public_path__ + "img/banner3.57926fe9.png";